<p>moving-step4-location works!</p>
